import {
    CreateEmotionDto,
    DeleteEmotionFromPeriodDto,
    EmocionResponseDto,
    UpdateEmotionDto,
} from '../interfaces/emotion';
import { request } from './Request';

/**
 * Servicio para manejar operaciones CRUD de emociones menstruales
 * Utiliza la clase Request para comunicarse con la API
 */
class EmotionService {
    private readonly baseEndpoint = '/emociones';

    /**
     * Obtiene todas las emociones de un usuario específico
     * @param id_usuario - ID del usuario para filtrar emociones
     * @returns Respuesta con lista de emociones del usuario
     */
    async getEmotionsByUser(id_usuario: number): Promise<EmocionResponseDto> {
        try {
            const response = await request.get<EmocionResponseDto>(
                `${this.baseEndpoint}/all/${id_usuario}`
            );
            return response.data;
        } catch (error) {
            console.error('Error al obtener emociones del usuario:', error);
            throw new Error('No se pudieron obtener las emociones del usuario');
        }
    }

    /**
     * Obtiene todas las emociones asociadas a un periodo específico
     * @param id_periodo - ID del periodo a consultar
     * @returns Respuesta con lista de emociones del periodo
     */
    async getEmotionsByIdPeriodo(id_periodo: number): Promise<EmocionResponseDto> {
        try {
            const response = await request.get<EmocionResponseDto>(
                `${this.baseEndpoint}/${id_periodo}`
            );
            return response.data;
        } catch (error) {
            console.error('Error al obtener emociones del periodo:', error);
            throw new Error('No se pudieron obtener las emociones del periodo');
        }
    }

    /**
     * Crea una nueva emoción para un periodo menstrual
     * @param payload - Datos de la nueva emoción (CreateEmotionDto)
     * @returns Respuesta con la emoción creada
     */
    async createEmotion(payload: CreateEmotionDto[]): Promise<EmocionResponseDto> {
        try {
            const response = await request.post<EmocionResponseDto>(
                `${this.baseEndpoint}`,
                payload
            );
            return response.data;
        } catch (error) {
            console.error('Error al crear la emoción:', error);
            throw new Error('No se pudo crear la emoción');
        }
    }

    /**
     * Actualiza parcialmente una emoción de un periodo existente
     * @param payload - Datos para actualizar la emoción (UpdateEmotionDto)
     * @returns Respuesta con la emoción actualizada
     */
    async updateEmotion(payload: UpdateEmotionDto[]): Promise<EmocionResponseDto> {
        try {
            const response = await request.patch<EmocionResponseDto>(
                `${this.baseEndpoint}`,
                payload
            );
            return response.data;
        } catch (error) {
            console.error('Error al actualizar la emoción:', error);
            throw new Error('No se pudo actualizar la emoción');
        }
    }

    /**
     * Elimina una emoción por su ID de periodo, ID de emoción y fecha
     * @param payload - Datos para eliminar la emoción (DeleteEmotionFromPeriodDto)
     * @returns Respuesta de confirmación de eliminación
     */
    async deleteEmotion(payload: DeleteEmotionFromPeriodDto[]): Promise<EmocionResponseDto> {
        try {
            const response = await request.delete<EmocionResponseDto>(
                `${this.baseEndpoint}`,
                payload
            );

            return response.data;
        } catch (error) {
            console.error('Error al eliminar la emocion:', error);
            throw new Error('No se pudo eliminar la emocion');
        }
    }


    //**  CATALOGO DE EMOCIONES */
    async getEmotions(): Promise<EmocionResponseDto> {
        try {
            const response = await request.get<EmocionResponseDto>(
                `catalogos/emocion/all`
            );
            return response.data;
        } catch (error) {
            console.error('Error al obtener el periodo:', error);
            throw new Error('No se pudo obtener el periodo');
        }
    }
}

// Exportar instancia singleton
export const emotionService = new EmotionService();

// Exportar la clase para crear instancias personalizadas si es necesario
export default EmotionService;